enum ContentMode {
  TRANSACTIONAL = 'transactional',
  PROMOTIONAL = 'promotional',
  OTP = 'OTP'
}

export default ContentMode;
